/**
 * Append-only free-text audit log on a Thing attribute.
 *
 * Two super-admin escape hatches on the locker console record why a human
 * overrode machine state — the SSTv2 migration flags (`migrationNote`) and the
 * operator service switch (`outOfServiceNote`). Both want the same shape, and
 * both are capped by their Joi schema, so the truncation rule lives in one place.
 *
 * Newest entry FIRST: the head of the field is always the current truth, which
 * matters because these fields are surfaced in a fixed-height UI block and read
 * top-down mid-incident. Appending at the tail would push the reason that
 * explains today's state off the bottom.
 *
 * Truncation is on the composed string, so a log at the cap loses its OLDEST
 * entries — never the one just written.
 */
export const appendNoteLine = (
  existing: string | undefined,
  line: string,
  max: number,
): string => [line, existing].filter(Boolean).join("\n").slice(0, max)
